<template>
	<div class="coi-panel">
		<!-- CoiAI注册用户列表(支持搜索) -->
		<div class="coi-list">
			<div class="coi-list-head">
				<span class="coi-list-title"><i class="el-icon-user"></i> CoiAI 用户列表</span>
				<div class="coi-user-filter">
					<el-select v-model="userQ.hasIosDevice" size="small" style="width:130px" @change="loadUsers(1)">
						<el-option label="全部用户" value=""></el-option>
						<el-option label="登录过iOS" value="true"></el-option>
						<el-option label="未登录iOS" value="false"></el-option>
					</el-select>
					<el-input v-model="userQ.search" placeholder="搜用户ID/邮箱/名称" size="small" clearable style="width:220px"
						@keyup.enter.native="loadUsers(1)" @clear="loadUsers(1)">
						<el-button slot="append" icon="el-icon-search" @click="loadUsers(1)"></el-button>
					</el-input>
				</div>
			</div>
			<el-table :data="userList" size="small" border v-loading="userLoading" empty-text="暂无用户数据" style="width:100%">
				<el-table-column label="ID" width="70" prop="id" align="center"></el-table-column>
				<el-table-column label="邮箱" min-width="180" prop="email" show-overflow-tooltip></el-table-column>
				<el-table-column label="名称" min-width="100" prop="name" show-overflow-tooltip></el-table-column>
				<el-table-column label="注册时间" width="140">
					<template slot-scope="s">{{ fmtTime(s.row.registeredAt) }}</template>
				</el-table-column>
				<el-table-column label="最近活跃" width="140">
					<template slot-scope="s">{{ fmtTime(s.row.lastActiveAt) }}</template>
				</el-table-column>
				<el-table-column label="iOS设备" width="80" align="center">
					<template slot-scope="s">
						<span v-if="s.row.hasIosDevice" class="coi-status-on">是</span>
						<span v-else class="coi-target-none">否</span>
					</template>
				</el-table-column>
				<el-table-column label="地区" min-width="110" prop="location" show-overflow-tooltip></el-table-column>
				<el-table-column label="操作" width="90" align="center">
					<template slot-scope="s">
						<el-button type="text" size="mini" icon="el-icon-s-promotion" @click="pickUser(s.row)">发券给他</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination class="coi-pager" background layout="prev, pager, next" :total="userTotal"
				:page-size="userQ.perPage" :current-page.sync="userQ.page" @current-change="loadUsers"
				v-if="userTotal > userQ.perPage"></el-pagination>
		</div>

		<!-- 发券表单 -->
		<div class="coi-form">
			<div class="coi-form-title"><i class="el-icon-present"></i> 发放优惠券</div>
			<el-form size="small" label-width="110px" class="coi-form-body">
				<div class="coi-form-row">
					<el-form-item label="券类型">
						<el-radio-group v-model="form.couponType" @change="onTypeChange">
							<el-radio label="discount">普通优惠码</el-radio>
							<el-radio label="ios">iOS优惠券</el-radio>
						</el-radio-group>
					</el-form-item>
					<template v-if="form.couponType === 'discount'">
						<el-form-item label="月卡折后价">
							<el-input v-model="form.monthlyPrice" placeholder="USDT" style="width:140px">
								<template slot="append">USDT</template>
							</el-input>
						</el-form-item>
						<el-form-item label="年卡折后价">
							<el-input v-model="form.yearlyPrice" placeholder="USDT" style="width:140px">
								<template slot="append">USDT</template>
							</el-input>
						</el-form-item>
						<el-form-item label="可用次数">
							<el-input v-model="form.maxUses" placeholder="默认1" style="width:110px"></el-input>
						</el-form-item>
					</template>
					<template v-else>
						<el-form-item label="适用套餐">
							<el-select v-model="form.planScope" style="width:150px">
								<el-option label="月卡 monthly" value="monthly"></el-option>
								<el-option label="季卡 quarterly" value="quarterly"></el-option>
								<el-option label="月卡+季卡 both" value="both"></el-option>
							</el-select>
						</el-form-item>
					</template>
					<el-form-item label="有效期(小时)">
						<el-input v-model="form.validHours" :placeholder="form.couponType === 'ios' ? '默认168' : '默认24'" style="width:110px"></el-input>
					</el-form-item>
				</div>
				<div class="coi-form-row">
					<el-form-item label="派发对象">
						<el-radio-group v-model="form.assignType">
							<el-radio label="none" :disabled="form.couponType === 'ios'">通用码(任何人可用)</el-radio>
							<el-radio label="email">定向-对方注册邮箱</el-radio>
							<el-radio label="user">定向-对方用户ID</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item v-if="form.assignType === 'email'" label="对方注册邮箱">
						<el-input v-model="form.assignEmail" placeholder="CoiAI系统注册邮箱" style="width:240px"></el-input>
					</el-form-item>
					<el-form-item v-if="form.assignType === 'user'" label="对方用户ID">
						<el-input v-model="form.assignUserId" placeholder="CoiAI用户ID,可在上方列表选" style="width:240px"></el-input>
					</el-form-item>
					<el-form-item label="备注">
						<el-input v-model="form.remark" placeholder="选填" style="width:200px"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" icon="el-icon-s-promotion" :loading="sending" @click="submit">发放</el-button>
					</el-form-item>
				</div>
				<div class="coi-form-tip">
					<template v-if="form.couponType === 'ios'">iOS优惠券要求目标用户曾登录过iOS设备,发放后自动进入对方 App「我的优惠券」。</template>
					<template v-else>定向码发放后自动进入对方 App「我的优惠券」并自动应用；通用码需把码串发给对方手动输入。</template>
				</div>
			</el-form>
		</div>

		<!-- 发放台账 -->
		<div class="coi-list">
			<div class="coi-list-head">
				<span class="coi-list-title">发放记录</span>
				<el-input v-model="keyword" placeholder="搜优惠码/邮箱/备注" size="small" clearable style="width:220px"
					@keyup.enter.native="load(1)" @clear="load(1)">
					<el-button slot="append" icon="el-icon-search" @click="load(1)"></el-button>
				</el-input>
			</div>
			<el-table :data="list" size="small" border v-loading="loading" empty-text="暂无发放记录" style="width:100%">
				<el-table-column label="优惠码" min-width="170">
					<template slot-scope="s">
						<span class="coi-code">{{ s.row.code }}</span>
						<el-button type="text" size="mini" icon="el-icon-document-copy" @click="copy(s.row.code)"></el-button>
					</template>
				</el-table-column>
				<el-table-column label="类型" width="100" align="center">
					<template slot-scope="s">
						<el-tag v-if="s.row.channel === 'ios'" size="mini" type="warning">iOS券</el-tag>
						<el-tag v-else size="mini">普通码</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="月卡价" width="80" align="center">
					<template slot-scope="s">{{ s.row.channel === 'ios' ? '-' : s.row.monthlyPrice }}</template>
				</el-table-column>
				<el-table-column label="年卡价" width="80" align="center">
					<template slot-scope="s">{{ s.row.channel === 'ios' ? '-' : s.row.yearlyPrice }}</template>
				</el-table-column>
				<el-table-column label="适用套餐" width="90" align="center">
					<template slot-scope="s">{{ planText(s.row.planScope) }}</template>
				</el-table-column>
				<el-table-column label="派发对象" min-width="150">
					<template slot-scope="s">
						<span v-if="s.row.assignEmail" class="coi-target">{{ s.row.assignEmail }}</span>
						<span v-else-if="s.row.assignUserId" class="coi-target">用户ID: {{ s.row.assignUserId }}</span>
						<span v-else class="coi-target-none">通用码</span>
					</template>
				</el-table-column>
				<el-table-column label="使用" width="70" align="center">
					<template slot-scope="s">{{ s.row.usedCount || 0 }}/{{ s.row.maxUses || 1 }}</template>
				</el-table-column>
				<el-table-column label="状态" width="80" align="center">
					<template slot-scope="s">
						<span v-if="s.row.isActive === false" class="coi-status-off">已失效</span>
						<span v-else-if="(s.row.usedCount || 0) >= (s.row.maxUses || 1)" class="coi-status-off">已用完</span>
						<span v-else class="coi-status-on">可用</span>
					</template>
				</el-table-column>
				<el-table-column label="失效时间" width="140">
					<template slot-scope="s">{{ fmtTime(s.row.validTo) }}</template>
				</el-table-column>
				<el-table-column label="备注" min-width="100" prop="remark" show-overflow-tooltip></el-table-column>
				<el-table-column label="发放人" width="80" prop="createdByName"></el-table-column>
				<el-table-column label="发放时间" width="140" prop="createdTime"></el-table-column>
				<el-table-column label="操作" width="90" align="center">
					<template slot-scope="s">
						<el-button type="text" size="mini" icon="el-icon-refresh" :loading="s.row._refreshing" @click="refresh(s.row)">刷新状态</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination class="coi-pager" background layout="prev, pager, next" :total="total"
				:page-size="pageSize" :current-page.sync="pageNo" @current-change="load"
				v-if="total > pageSize"></el-pagination>
		</div>
	</div>
</template>

<script>
import bizApi from '../../api/bizApi.js';

export default {
	name: 'CoiCouponManage',
	data() {
		return {
			userQ: { search: '', hasIosDevice: '', page: 1, perPage: 10 },
			userList: [], userTotal: 0, userLoading: false,
			form: {
				couponType: 'discount',
				monthlyPrice: '', yearlyPrice: '', validHours: '', maxUses: '',
				planScope: 'monthly',
				assignType: 'email', assignEmail: '', assignUserId: '', remark: ''
			},
			sending: false,
			list: [], total: 0, pageNo: 1, pageSize: 20, keyword: '', loading: false
		};
	},
	created() {
		this.loadUsers(1);
		this.load(1);
	},
	methods: {
		loadUsers(page) {
			if (page) this.userQ.page = page;
			this.userLoading = true;
			const params = { page: this.userQ.page, perPage: this.userQ.perPage };
			if (this.userQ.search.trim()) params.search = this.userQ.search.trim();
			if (this.userQ.hasIosDevice !== '') params.hasIosDevice = this.userQ.hasIosDevice;
			bizApi.coiUsers(params).then((d) => {
				this.userList = (d && d.list) || [];
				this.userTotal = (d && d.total) || 0;
			}).catch(() => { }).finally(() => { this.userLoading = false; });
		},
		pickUser(row) {
			this.form.assignType = 'user';
			this.form.assignUserId = String(row.id);
			this.form.assignEmail = row.email || '';
			this.$message.success('已选用户 ' + row.id + '(' + (row.email || '') + '),请填写券信息后发放');
			this.$nextTick(() => {
				const el = document.querySelector('.coi-form');
				if (el && el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
			});
		},
		onTypeChange(t) {
			// iOS券必须定向,通用码选项不可用
			if (t === 'ios' && this.form.assignType === 'none') {
				this.form.assignType = 'email';
			}
		},
		submit() {
			const f = this.form;
			if (f.couponType === 'discount') {
				if (!f.monthlyPrice || isNaN(Number(f.monthlyPrice)) || Number(f.monthlyPrice) < 0) {
					return this.$message.warning('请填写正确的月卡折后价');
				}
				if (!f.yearlyPrice || isNaN(Number(f.yearlyPrice)) || Number(f.yearlyPrice) < 0) {
					return this.$message.warning('请填写正确的年卡折后价');
				}
			}
			if (f.assignType === 'email' && !f.assignEmail.trim()) {
				return this.$message.warning('请填写对方注册邮箱');
			}
			if (f.assignType === 'user' && !f.assignUserId.trim()) {
				return this.$message.warning('请填写对方用户ID');
			}

			let req;
			if (f.couponType === 'ios') {
				req = { planScope: f.planScope };
				if (f.assignType === 'email') req.assignEmail = f.assignEmail.trim();
				else if (f.assignType === 'user') req.assignUserId = Number(f.assignUserId.trim());
				else return this.$message.warning('iOS优惠券必须指定目标用户');
			} else {
				req = { monthlyPrice: Number(f.monthlyPrice), yearlyPrice: Number(f.yearlyPrice) };
				if (f.maxUses && Number(f.maxUses) > 0) req.maxUses = Number(f.maxUses);
				if (f.assignType === 'email') req.assignEmail = f.assignEmail.trim();
				else if (f.assignType === 'user') req.assignUserId = Number(f.assignUserId.trim());
			}
			if (f.validHours && Number(f.validHours) > 0) req.validHours = Number(f.validHours);
			if (f.remark.trim()) req.remark = f.remark.trim();

			this.sending = true;
			const api = f.couponType === 'ios' ? bizApi.coiCreateIosCoupon(req) : bizApi.coiCreateCode(req);
			api.then((d) => {
				this.$message.success('发放成功：' + (d.code || ''));
				this.form.monthlyPrice = ''; this.form.yearlyPrice = ''; this.form.validHours = '';
				this.form.maxUses = ''; this.form.assignEmail = ''; this.form.assignUserId = ''; this.form.remark = '';
				this.load(1);
			}).catch(() => { }).finally(() => { this.sending = false; });
		},
		load(page) {
			if (page) this.pageNo = page;
			this.loading = true;
			bizApi.coiCodePage(this.pageNo, this.pageSize, this.keyword).then((d) => {
				this.list = (d && d.list) || [];
				this.total = (d && d.total) || 0;
			}).catch(() => { }).finally(() => { this.loading = false; });
		},
		refresh(row) {
			this.$set(row, '_refreshing', true);
			bizApi.coiCodeStatus(row.id).then((d) => {
				row.usedCount = d.usedCount;
				row.isActive = d.isActive;
				if (d.validTo) row.validTo = d.validTo;
				this.$message.success(d.usable === false ? '该码当前不可用' : '状态已刷新');
			}).catch(() => { }).finally(() => { this.$set(row, '_refreshing', false); });
		},
		planText(p) {
			const map = { monthly: '月卡', quarterly: '季卡', both: '月卡+季卡' };
			return map[p] || '-';
		},
		// ISO8601(UTC) → 本地时间显示
		fmtTime(v) {
			if (!v) return '-';
			const d = new Date(v);
			if (isNaN(d.getTime())) return v;
			const p = (x) => (x < 10 ? '0' : '') + x;
			return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate()) + ' ' + p(d.getHours()) + ':' + p(d.getMinutes());
		},
		copy(text) {
			const done = () => this.$message.success('已复制优惠码');
			if (navigator.clipboard && navigator.clipboard.writeText) {
				navigator.clipboard.writeText(text).then(done).catch(() => this.legacyCopy(text, done));
			} else {
				this.legacyCopy(text, done);
			}
		},
		legacyCopy(text, done) {
			const ta = document.createElement('textarea');
			ta.value = text;
			ta.style.position = 'fixed';
			ta.style.opacity = '0';
			document.body.appendChild(ta);
			ta.select();
			try { document.execCommand('copy'); done(); } catch (e) { this.$message.warning('复制失败，请手动复制'); }
			document.body.removeChild(ta);
		}
	}
};
</script>

<style lang="scss" scoped>
.coi-panel { padding: 4px 0; }
.coi-form {
	background: #fff; border: 1px solid #ebeef5; border-radius: 6px; padding: 14px 18px 4px; margin-bottom: 14px;
	.coi-form-title { font-size: 14px; font-weight: 600; color: #303133; margin-bottom: 10px; }
	.coi-form-row { display: flex; flex-wrap: wrap; align-items: flex-start; }
	.coi-form-tip { color: #909399; font-size: 12px; padding-bottom: 10px; }
}
.coi-list {
	background: #fff; border: 1px solid #ebeef5; border-radius: 6px; padding: 14px 18px; margin-bottom: 14px;
	.coi-list-head { display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px; }
	.coi-list-title { font-size: 14px; font-weight: 600; color: #303133; }
}
.coi-user-filter { display: flex; gap: 8px; }
.coi-code { font-family: Menlo, Consolas, monospace; color: #409eff; }
.coi-target { color: #303133; }
.coi-target-none { color: #909399; }
.coi-status-on { color: #67c23a; }
.coi-status-off { color: #f56c6c; }
.coi-pager { margin-top: 12px; text-align: right; }
</style>
